import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';

/* О записи «ResizeObserver loop completed with undelivered notifications»
 * в консоли при открытии выпадающих списков.
 *
 * Это не падение. Уведомление браузера: обработчик наблюдателя за
 * размерами вызвал новое изменение размеров, и браузер отложил остаток
 * уведомлений на следующий кадр. Петлю он разрывает сам. Возникает на
 * выпадающих списках Radix.
 *
 * Красный экран во весь экран рисует оверлей дев-сервера, который
 * показывает любую неперехваченную ошибку. В боевой сборке его нет вовсе:
 * проверено на выкаченном бандле main.7a11afc9.js — ни одного вхождения
 * «Uncaught runtime errors», «webpack-dev-server-client-overlay» и
 * «react-error-overlay». Прод — статика в nginx, собранная npm run build.
 *
 * Здесь НЕ ставим ни перехват события, ни подмену ResizeObserver, и вот
 * почему — обе попытки были сделаны и отклонены по замеру:
 *
 *   1. stopImmediatePropagation не достаёт до оверлея: свой обработчик
 *      дев-сервер вешает раньше нашего.
 *   2. Подмена ResizeObserver с переносом вызова на requestAnimationFrame
 *      отклонена как несоразмерная: глобальную браузерную возможность
 *      подменять ради записи в консоли, которой в бою нет, не стоит.
 *
 *      Проверить её действие не удалось: в фоновой вкладке наблюдатель не
 *      вызывается вовсе — ни подменённый, ни родной (замерено оба раза по
 *      нулю). Сначала я счёл этот ноль доказательством, что подмена ломает
 *      наблюдатель; это был неверный вывод — ноль оказался свойством
 *      фоновой вкладки. Так что довод против подмены только один: она
 *      несоразмерна, а не «проверено, что ломает».
 *
 * Итог: терпим запись в разработке, в бою её нет. Если она начнёт мешать
 * всерьёз — возвращаться к подмене, но замерять на ПЕРЕДНЕЙ вкладке. */

createRoot(document.getElementById('root')).render(<App />);

// Service worker нужен только ради push-уведомлений: без него браузер не
// даст подписаться. Ошибку регистрации глушим — без уведомлений CRM
// работает, а падать из-за них не должна.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}
